import { render, staticRenderFns } from "./ModalTrademartPartnership.vue?vue&type=template&id=9096a898"
import script from "./ModalTrademartPartnership.vue?vue&type=script&lang=js"
export * from "./ModalTrademartPartnership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseModal: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/09062026_084924/resources/assets/marketplace/components/BaseModal.vue').default})
